import React, { useEffect, useMemo } from 'react';
import { formatFileSize, kindOfFile } from './utils';

/**
 * Renders the attachment of a not-yet-confirmed message straight from the
 * local `File` object (no server URL exists yet at this point).
 */
const PendingAttachment = ({ file }) => {
  const kind = kindOfFile(file);

  const previewUrl = useMemo(() => (kind === 'image' ? URL.createObjectURL(file) : null), [file, kind]);

  useEffect(() => {
    return () => {
      if (previewUrl) URL.revokeObjectURL(previewUrl);
    };
  }, [previewUrl]);

  if (kind === 'image') {
    return <img src={previewUrl} alt={file.name} className="mt-2 max-w-full rounded-xl max-h-80 object-contain opacity-70" />;
  }

  return (
    <p className="mt-2 inline-flex items-center gap-2 text-sm text-gray-500">
      📎 {file.name}
      {file.size ? ` (${formatFileSize(file.size)})` : ''}
    </p>
  );
};

export default PendingAttachment;
